<template>
    <Transition name="sPBOverlayTransition">
        <div class="sPBOverlay" v-if="isOpen">
            <button type="button" class="sPBOverlay__close" @click="$emit('close')">
                <span class="sPBOverlay__close__lines"></span>
                <span class="sr-only">Close</span>
            </button>

            <div class="sPBOverlay__body">
                <slot />
            </div>
        </div>
    </Transition>
</template>

<script>
export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        document.addEventListener('keydown', this.escClose)
        document.body.appendChild(this.$el)
    },
    destroyed() {
        document.removeEventListener('keydown', this.escClose)
        this.$el.remove()
    },
    methods: {
        escClose (e) {
            if (e.key === 'Escape') {
                this.$emit('close')
            }
        }
    },
    watch: {
        isOpen(value) {
            if (value) {
                document.documentElement.classList.add('noScroll')
                document.body.classList.add('sPBOverlayOpen')
            } else {
                document.documentElement.classList.remove('noScroll')
                document.body.classList.remove('sPBOpen')
            }
        }
    }
}
</script>